import { useGlobalContext } from '@/globalContext';
import { useNavigate } from 'react-router-dom';
import useNotify from '@hooks/useNotify';
import Config from '@utils/config';
import AccountService from '@api/account/account';
import { useEffect } from 'react';
import { AxiosError } from 'axios';
import { LOGIN_PATH } from '@utils/constants/Routes';
import { INVALID_SESSION_ERROR_CODE } from '@models/account';
import { isApiError } from '@api/base';

const accountService = new AccountService(Config.apiUrl);

export const useLogOut = (
    error: AxiosError<unknown> | undefined,
    onError: (error: Error) => void,
) => {
    const { set } = useGlobalContext();
    const navigate = useNavigate();
    const notify = useNotify();

    useEffect(() => {
        if (!error) return;

        if (isApiError(error) && error.response?.data?.error_code === INVALID_SESSION_ERROR_CODE) {
            notify({
                message: 'Session expired',
                variation: 'danger',
                icon: true,
            });
            accountService.logout();
            set((prev) => ({ ...prev, account: undefined, accountChecked: false }));
            navigate(LOGIN_PATH, { replace: true });
        } else {
            onError(error);
        }
    }, [error, onError, set, notify, navigate]);
};
